import { __rest } from '../../node_modules/tslib/tslib.es6.js';
import { jsx } from 'react/jsx-runtime';
import cns from '../../node_modules/classnames/index.js';

function getTestIdByDisplayName(displayName) {
    return displayName && displayName.replace('Icon', '-icon').toLowerCase();
}
const Icon = (path, customViewBox, displayName) => {
    function BaseIcon(_a) {
        var { className = '', inverted = false, selected = false, small = false, viewBox = '' } = _a, others = __rest(_a, ["className", "inverted", "selected", "small", "viewBox"]);
        const classes = cns('icon', {
            'icon--inverted': inverted,
            'icon--small': small,
            'icon--selected': selected,
        }, className);
        return (jsx("svg", Object.assign({ className: classes, viewBox: viewBox || customViewBox || '0 0 50 50', "data-testid": getTestIdByDisplayName(displayName) }, others, { children: path })));
    }
    BaseIcon.displayName = displayName;
    return BaseIcon;
};

export { Icon as default, getTestIdByDisplayName };
